import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export async function subscribeEmail(email, source = 'website') {
  const res = await axios.post(`${API}/subscribe`, { email, source });
  return res.data;
}

export async function sendContact(payload) {
  const res = await axios.post(`${API}/contact`, payload);
  return res.data;
}
